export const MY_HARDWARE_QUERY_KEY = ["my-hardware"] as const;
